<!--
  Component to handle display of toaster content with an action button
  Emits:
  - close-toast   # internal vue-toastification emit that triggers closing of toaster
  - click-sync    # Fired on click on sync page button
-->
<script setup lang="ts">
import Text from '@/components/text/Text.vue';

type Props = { text: string; icon: string };
const emits = defineEmits(['close-toast', 'click-action']);
const props = defineProps<Props>();
function clickAction() {
  emits('close-toast');
  emits('click-action');
}
</script>

<template>
  <div class="d-flex align-center">
    <Text id="toastText" type="body3">{{ props.text }}</Text>

    <button class="action-btn" @click="clickAction">
      <font-awesome-icon :icon="props.icon" class="color-primaryIcon" aria-labelledby="toastText" />
    </button>
  </div>
</template>

<style scoped lang="scss">
.action-btn {
  border: 1px solid rgb(var(--v-theme-btnSecondaryBorder));
  background-color: rgb(var(--v-theme-on-btnSecondary));
  margin-inline-start: 24px;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  flex-shrink: 0;
}
</style>
